import assets from 'themes/base/assets';
import LOGO from './images/logo.png';

export default {
  ...assets,
  LOGO,
};
